<!--
    如何测试分页？这里使用到了后台 mock data 的方式，调用 test-invitecode-trace-dao 的 "create batches" 测试用例批量创建出测试数据。
-->
<template>
    <my-dialog ref="dialog" title="我的邀请记录">
        <el-card>
            <div ref='list-wrap' class="list-wrap">
                <el-table :data="tableData" stripe style="width: 100%" :size="tableSize" :empty-text="tableDesc">
                    <!--
                    el-table-column 的响应式：很垃圾，必须给定一个数值，而默认情况下，el-table-column 是以等分屏幕宽度作为比例显示的，
                    比如 iphone 5 屏幕的尺寸是 320，那么默认情况下，4 个 column 的话等分后每个 column 宽度是 80。经过精密的计算，
                    在 iphone 尺寸下，只要日期的比例在 0.1875，那么 el-table-column 在手机侧可以做到响应式了
                    -->
                    <el-table-column prop="date" label="日期" :width="responsiveColumnWidth.dateColumnWidth" align="center"></el-table-column>
                    <el-table-column prop="invitee" label="对方用户名" :width="responsiveColumnWidth.inviteeColumnWidth" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="inviteeRewardPoints" label="对方获得积分" :width="responsiveColumnWidth.inviteeRewardPointsColumnWidth" align="center"></el-table-column>
                    <el-table-column prop="inviterRewardPoints" label="你获得的积分" :width="responsiveColumnWidth.inviterRewardPointsColumnWidth" align="center"></el-table-column>
                </el-table>
                <no-signal
                    v-if='noSignalVisible'
                    ref="noSignal"
                    :display-mode="noSignalDisplayMode"
                    :retry-handlers="[nextPage]"
                    :retry-basis="false"
                    :margin-top="0"></no-signal>
            </div>
            <!-- mugen scroll 的注意事项参考 UserCommentTemplate.vue -->
            <mugen-scroll :handler="nextPage"
                          :handle-on-mount="false"
                          :should-handle="!loading && !isLastPage"
                          scroll-container="list-wrap" >
                <!-- 不要和全局的 loading 冲突，因此将下面的 loading 给注释掉 -->
                <!-- <loading :text="null" v-show="loading && !isLastPage"></loading>-->
                <!-- <span align="center" v-show="loading && !isLastPage" style="font-size:12px" class="font-gray">加载中...</span>-->
            </mugen-scroll>
            <div align="right" style="font-size:12px;margin-right:10px;padding-top:4px" class="font-gray">积分合计：<span class="font-black">{{total}}</span></div>
        </el-card>
    </my-dialog>
</template>

<script>
    import MyDialog from "../../commons/MyDialog";
    import {DateFormat, errorMessage, GlobalLoading, isMiniPhoneAgent, isPhoneAgent} from "../../../utils";
    import { isEmailActivated, loadInviteCodeTrace } from "../../../data/user";
    import MugenScroll from '@shangyang/vue-mugen-scroll'
    import { getInviteCodeTraceTotal } from "../../../data/user";
    import { TimeoutError, NetworkError } from '@shangyang/error';

    export default {
        name: "UserInviteHis",
        components: {MyDialog, MugenScroll},
        computed: {
            tableSize: function(){
                if(isPhoneAgent()){
                    return 'mini';
                }else{
                    return 'medium'
                }
            },
            /**
             * el-table-column 的响应式：很垃圾，必须给定一个数值，而默认情况下，el-table-column 是以等分屏幕宽度作为比例显示的，
             * 比如 iphone 5 屏幕的尺寸是 320，那么默认情况下，4 个 column 的话等分后每个 column 宽度是 80。经过精密的计算，
             * 在 iphone 尺寸下，只要日期的比例在 0.1875，那么 el-table-column 在手机侧可以做到响应式了
             */
            responsiveColumnWidth: function(){
                const table_max_width = 620
                let padding = isMiniPhoneAgent() ? 20 : 32;
                let max_width = window.innerWidth > 700 ? table_max_width : window.innerWidth - padding;
                let rspvWidth = {
                    dateColumnWidth: max_width * 0.25,
                    inviteeColumnWidth: max_width * 0.25,
                    inviteeRewardPointsColumnWidth: max_width * 0.25,
                    inviterRewardPointsColumnWidth: max_width * 0.25
                }
                return rspvWidth;
            }
        },
        data(){
            return {
                tableData: [],
                tableDesc: '数据加载中...',
                noData: false,
                pageNum: 1,
                loading: false,
                isLastPage: false,
                total: 0, // 邀请人通过邀请码获得的奖励积分总和
                noSignalVisible: false,
                noSignalDisplayMode: 'vertical'
            }
        },
        methods: {

            show() {
                // 延时显示
                setTimeout(() => {
                    this.$refs.dialog.show();
                }, 300);
                this.reset();
                this.init();
            },

            reset(){
                this.tableData = [];
                this.tableDesc = '数据加载中...';
                this.noData = false;
                this.pageNum = 1;
                this.loading = false;
                this.isLastPage = false;
                this.noSignalVisible = false;
            },

            async init(){
                this.user = this.$store.getters.getUser();
                this.nextPage();
                this.total = await getInviteCodeTraceTotal();
            },

            async nextPage(){
                try {
                    this.loading = true;
                    let traces = await loadInviteCodeTrace.bind(this)(this.pageNum);
                    if (traces === undefined || traces === null || traces.length === 0){
                        if (this.pageNum === 1){
                            this.tableDesc = '暂无数据'
                            this.noData = true;
                        }else{
                            this.isLastPage = true
                        }
                    }else{
                        for (let t of traces) {
                            this.tableData.push({
                                date: DateFormat.responsiveYyMmDdFormat(t.activate_ts),
                                invitee: t.invitee_username,
                                inviteeRewardPoints: t.invitee_reward_points,
                                inviterRewardPoints: t.inviter_reward_points
                            })
                        }
                        this.pageNum += 1
                    }
                    // this.__addMockData();
                    this.noSignalVisible = false;
                }catch(error){
                    console.error(error);
                    // 如果是第一页就出现了网络异常，将其切换成 main page 异常。
                    if (error instanceof TimeoutError || error instanceof NetworkError) {
                        errorMessage(error.message);
                        this.noSignalVisible = true; // 显示 no signal comp
                        if (this.pageNum === 1){
                            this.noSignalDisplayMode = 'vertical'
                        } else { // page num > 1
                            this.noSignalDisplayMode = 'horizental'
                        }
                    }
                    this.tableDesc = '数据加载失败'
                }finally{
                    this.loading = false;
                }
            },

            // adds some test data for 排版
            __addMockData(){
                this.tableData.push({
                    date: DateFormat.responsiveYyMmDdFormat(new Date()),
                    invitee: 'shagnyangdkfjdkfd',
                    inviteeRewardPoints: 10,
                    inviterRewardPoints: 5
                });
                this.tableData.push({
                    date: DateFormat.responsiveYyMmDdFormat(new Date()),
                    invitee: 'shagnyangdkfjdkfd',
                    inviteeRewardPoints: 10,
                    inviterRewardPoints: 5
                });
                this.tableData.push({
                    date: DateFormat.responsiveYyMmDdFormat(new Date()),
                    invitee: 'shagnyangdkfjdkfd',
                    inviteeRewardPoints: 10,
                    inviterRewardPoints: 5
                });
                this.tableData.push({
                    date: DateFormat.responsiveYyMmDdFormat(new Date()),
                    invitee: 'shagnyangdkfjdkfd',
                    inviteeRewardPoints: 10,
                    inviterRewardPoints: 5
                });
                this.tableData.push({
                    date: DateFormat.responsiveYyMmDdFormat(new Date()),
                    invitee: 'shagnyangdkfjdkfd',
                    inviteeRewardPoints: 10,
                    inviterRewardPoints: 5
                });
            }
        }
    }
</script>

<style scoped>

    /deep/ .dialog-content-panel{
        /* overflow: auto; */ /* fix HCF-345：真机环境下，用户喜欢列表不能完全弹出 entity，是因为此时的 popup entity 的行为很诡异，它的父类节点不能有任何一个是 overflow: auto/scroll 的*/
        height: 440px !important;
    }

    /deep/ .list-wrap{
        height: 400px !important;
    }

    /deep/ .el-card__body{
        padding: 4px !important;
    }

    /* 手机中的小屏幕 */
    @media (max-width: 540px) {
        /* 调整手机端 cell 两侧的 padding，默认是 10px 太大了 */
        /deep/ .el-table .cell {
            padding: 0 2px 0 0 !important;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/user/center/UserInviteHis.vue